import React from 'react';
import { AppBar, Toolbar, Typography, Box, InputBase } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import NotificationDropdown from './NotificationDropdown';
import ProfileDropdown from './ProfileDropdown';
import ThemeToggle from './ThemeToggle';
import { useContext } from 'react';
import { SettingsContext } from '../context/SettingsContext';

function SuperAdminHeader() {
  const settings = useContext(SettingsContext);
  const API_BASE = (process.env.REACT_APP_API_URL || '').replace(/\/+$/,'');
  const logoSrc = settings?.logoUrl || `${API_BASE}/api/public/logo`;
  const platformName = settings?.platformName || 'Expo & Conference Platform';
  return (
    <AppBar position="static" color="inherit" elevation={2} sx={{ mb: 2, borderRadius: 2, boxShadow: 3 }}>
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', minHeight: 72 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <img src={logoSrc} alt={platformName} style={{ height: 44, width: 44, objectFit: 'contain', marginRight: 12, borderRadius: 4, background: '#fff', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }} />
          <Typography variant="h5" sx={{ fontWeight: 800, letterSpacing: 1, color: 'primary.main' }}>
            {platformName} <span style={{ fontWeight: 400, color: '#888', fontSize: '1.1rem', marginLeft: 8 }}>| Super Admin Panel</span>
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box sx={{ bgcolor: 'background.paper', px: 1, borderRadius: 1, display: 'flex', alignItems: 'center', minWidth: { xs: 100, md: 200 } }}>
            <SearchIcon color="action" />
            <InputBase placeholder="Search…" sx={{ ml: 1, flex: 1 }} />
          </Box>
          <NotificationDropdown />
          <ProfileDropdown />
          <ThemeToggle />
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default SuperAdminHeader;
